import React from 'react';
import { Card } from 'antd';
import styled from 'styled-components';

const CardComp = props => <Card {...props} />;

const CustomCard = styled(CardComp)`
  .ant-card-head {
    background-color: #fafafa;
    border-bottom: 1px solid #e9e9e9;

    .ant-card-head-title {
      color: #323332;
    }
  }

  .ant-card-extra {
    a {
      color: #4482FF;
      text-decoration: none;

      &:focus {
        text-decoration: none;
      }
    }
  }

  .ant-card-body {
    p {
      font-size: 13px;
      color: #797979;
      line-height: 1.5;
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.ant-card-bordered {
    border: 1px solid #e9e9e9;

    .ant-card-head {
      border-bottom: 1px solid #e9e9e9;
    }

    &:hover {
      border: 1px solid #e9e9e9 !important;
    }
  }

  &.ant-card-loading {
    .ant-card-body {
      p {
        margin-bottom: 0;
      }
    }
  }

  .custom-card {
    padding: 10px 16px;
    h3 {
      color: #595959;
      font-weight: 500;
    }
    p {
      color: #bababa;
    }
  }

  .custom-image img {
    display: block;
  }
`;

export default CustomCard;



// WEBPACK FOOTER //
// ./src/components/Orders/Modals/card.style.js